import React from 'react';
import { ApolloProvider } from '@apollo/client';
import AppSyncClient from 'config/AppSyncClient';

const WithApolloProvider = ({ children, config }) => {
  const client = AppSyncClient(config);

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

export default WithApolloProvider;
